import BaseService from './BaseService'

class ProfileService extends BaseService {
  constructor() {
    super('/profile')
  }

  /**
   * @param {Record<string, unknown>} partial - e.g. { tables: { customers: ['photo', 'city'] } }
   */
  async patchPreferences(partial) {
    return this.customRequest('patch', '/preferences', partial)
  }

  async getDashboardDigestSendStatus() {
    return this.customRequest('get', '/dashboard-digests/send-status')
  }

  async sendDashboardDigestNow(digestType) {
    return this.customRequest('post', '/dashboard-digests/send', {
      digest_type: digestType
    })
  }
}

export const profileService = new ProfileService()
